import Header from '../components/Header'

const Home = () => {
  return (
    <div>
      <Header />
    </div>
  );
};

export default Home